import React from "react";
import GMLL from "../images/contenido/GustavoMohmeLlona30.jpg";
import Padres from "../images/contenido/0 Gustavo Mohme Llona 07.jpg";
import MohmeJoven from "../images/contenido/GMohme-SMiller.jpg";
import Mohme21 from "../images/contenido/21 foto.jpg";
import Mohme23 from "../images/contenido/Gustavo Mohme Llona 23.jpg";
import Mohme8 from "../images/contenido/GUSTAVO MOHME LLONA 8.jpg";
import Mohme from "../images/contenido/Gustavo Mohme Llona.jpg";
import Mohme22 from "../images/contenido/GUSTAVO 22-SDARC-86442.jpg";
import Mohme7 from "../images/contenido/MOHME LLONA Gustavo 7.jpg";
import Mohme26 from "../images/contenido/26 GUSTAVO MOHME LLONA 16.jpg";
import Mohme37 from "../images/contenido/37 PRErepubl109.jpg";
import Mohme47 from "../images/contenido/47 B FACHADA REPUBLICA 01.jpg";
import Mohme36 from "../images/contenido/36 SORE18B - Concertador.jpg";
import Javier from "../images/contenido/JAVIER DIEZ CANSECO  04-SDARC-5775579.jpg";
import Mohme31 from "../images/contenido/31 GUSTAVO MOHME LLONA 11_AD_573795.jpg";
import Mohme45 from "../images/contenido/45 MohmeCarlin.jpg";
import Navigation from "../components/Navigation";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet";

const C1Nosotros = () => {
  return (
    <section className="nosotros">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Gustavo Mohme Llona - Memoria 2014-2024 - Fundación Gustavo Mohme
          Llona
        </title>
        <meta
          property="og:title"
          content="Gustavo Mohme Llona - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <Fade delay={100} triggerOnce>
              <div className="pre-title">1.1</div>
              <h1 className="color-red">Gustavo Mohme Llona</h1>
              <div className="post-title">(1930-2000)</div>
            </Fade>
          </div>
          <div className="column-0">
            <Fade delay={400} duration="2000" cascade triggerOnce>
              <div className="cont-mohme-0">
                <img src={GMLL} alt="Gustavo Mohme Llona" className="mohme-0" />
                <div className="block-red"></div>
              </div>
              <div className="block-red-light"></div>
            </Fade>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <Fade delay={100} triggerOnce damping={0.05} fraction={0} cascade>
              <p>
                Gustavo Mohme Llona fue una persona sencilla y valiosa. Su vida
                atesora experiencias aleccionadoras de innegable valor humano y
                su conocimiento ayudaría a fortalecernos como personas y
                sociedad, pero su historia es poco conocida. Traerla a la
                actualidad es un deber.
              </p>
              <figure className="img-left">
                <div className="block-red"></div>
                <img
                  src={Padres}
                  alt="Sus padres, Gustav Mohme y Stella Llona."
                />
                <div className="legend">
                  Sus padres, Gustav Mohme y Stella Llona.
                </div>
              </figure>
              <p>
                En 1930, el mundo vivía los efectos de la crisis financiera de
                1929-1932 a raíz del desplome de la Bolsa de Valores de Nueva
                York. En Perú bajaban los precios de los productos de
                exportación y los ingresos fiscales. El desempleo crecía. El sol
                de oro desplazaba a la libra peruana. Y el comandante Luis M.
                Sánchez Cerro se disponía a deponer al presidente Augusto B.
                Leguía.
              </p>

              <p>
                El 25 de abril de ese año nació Gustavo Mohme Llona en Yapatera,
                Piura, fruto de la unión de Stella Llona Miller con Gustav
                Mohme. Ella, una joven amante de la pintura y el teatro, hija
                del científico Scipión Llona. Y él, un migrante alemán radicado
                en EE. UU., promotor del cine mudo y sonoro del país del norte
                en México, Argentina, Chile y Perú. Aquí se conocieron.
              </p>

              <p>
                La unión conyugal no prosperó. Gustav padre retornó a su país. Y
                en julio de 1930, la joven madre y su pequeño se embarcaron
                rumbo a Milán, Italia. Voy con “el afán de triunfar y ganar
                dinero por mi hijito”, contó Stella en una carta familiar.
                Trabajó casi dos años esquivando quiebras y despidos, hasta que
                tantas vicisitudes la abatieron el 14 de junio de 1932.
              </p>
              <figure className="img-right">
                <div className="block-red-light"></div>
                <img src={MohmeJoven} alt="Con su abuela, Stella Miller." />
                <div className="legend">Con su abuela, Stella Miller.</div>
              </figure>
              <p>
                A temprana edad, Gustavo Mohme Llona conoció la adversidad.
                Tenía dos años y dos meses cuando quedó huérfano, lejos de su
                patria. Volvió a Perú de la mano de una amiga de la familia,
                quien lo entregó a su abuela Stella Miller y a sus tíos:
                Adriana, que le costeó los estudios, y Augusto, su orientador y
                amigo inseparable. Ese apoyo familiar y el amor intenso que le
                prodigó su madre y que lo acompañó toda su vida templaron su
                carácter.
              </p>

              <p>
                Creció y estudió primaria en Barranco. La secundaria la cursó en
                el Colegio Angloamericano, hoy San Andrés, de 1941 a 1945.
                Concluido ese ciclo, perdió a su abuela Stella Miller, la dama
                que lo crio desde los 3 hasta los 15 años. Juntos habían
                celebrado el fin de la Segunda Guerra Mundial, pero ella ya no
                estuvo cuando él ingresó a la Escuela Nacional de Ingeniería.
              </p>
              <br />
              <figure className="img-left img-mohme-5">
                <div className="block-red-light"></div>
                <img
                  src={Mohme21}
                  alt="Durante una jornada de trabajo en los años iniciales de la constructora."
                  className="img-mohme-5"
                />
                <div className="legend">
                  Durante una jornada de trabajo en los años iniciales de la
                  constructora.
                </div>
              </figure>
              <p>
                Su vocación fueron las matemáticas y el amor a su país. La
                inclinación le venía por línea materna. Su abuelo Scipión Llona
                fue secretario de la Sociedad Geográfica de Lima hasta su
                fallecimiento y autor de una teoría sobre el origen de los
                movimientos sísmicos. El abuelo tuvo también como maestro
                personal al matemático Federico Villarreal y fue discípulo del
                ingeniero y científico José Granda.
              </p>

              <p>
                Los tres primeros años de la carrera de Ingeniería (1946-1948)
                los aprobó bajo la “primavera democrática” del gobierno de
                Bustamante y Rivero. Y ya sus dos últimos años de estudios
                (1949-1950) coincidieron con el golpe de Estado y la dictadura
                del general Manuel Odría. Esa puja, democracia vs.
                autoritarismo, le enseñó a valorar las libertades.
              </p>

              <p>
                Los primeros planos de ingeniería fueron sus propios proyectos
                de vida, encaminados hacia tres objetivos estratégicos: hacer
                empresa, fundar un hogar y participar en política. Metas que se
                trazó en plena juventud y ejecutó a corto, mediano y largo
                plazo. Fue un trazo visionario.
              </p>
              <div className="quote">
                "Cuando toda paz verdadera parece imposible es justamente el
                momento de ponerse manos a la obra".
              </div>
              <p>
                Construyó empresa. En 1954 se asoció con Arturo Woodman y formó
                Woodman & Mohme, edificadora de numerosas obras: la Panamericana
                Norte (tramo del kilómetro 50 al 65), los colegios estatales Ann
                Goulden, Primavera y José Carlos Mariátegui; mercados, parques,
                losas deportivas y otras obras públicas por las que nunca
                recibió una sola denuncia por corrupción.
              </p>

              <p>
                Fue un empresario transparente. Apostó por una economía de
                mercado con empresas respetuosas de los derechos de los
                trabajadores. El empresario debía aspirar a una ganancia
                razonable y no al lucro ni a la coima. Tampoco debían tenderse
                muros entre dueños y trabajadores, sino propiciar el
                entendimiento. Él mismo, desde la Cámara Peruana de la
                Construcción, propició acuerdos sobre los pliegos de reclamos de
                los trabajadores de esa rama.
              </p>
              <figure className="img-right img-mohme-5">
                <div className="block-circle"></div>
                <img
                  src={Mohme23}
                  alt="Día del matrimonio religioso con Helena Ramona Seminario
                Requena."
                  className="img-mohme-5"
                />
                <div className="legend">
                  Día del matrimonio religioso con Helena Ramona Seminario
                  Requena.
                </div>
              </figure>
              <p>
                Fundó familia. En enero de 1956, contrajo matrimonio con Helena
                Ramona Seminario Requena, joven natural del distrito petrolero
                El Alto, provincia de Talara, Piura. Con ella construyó un hogar
                estable y unido, sustentado en el amor y el respeto, con una
                prole de seis hijos: Stella, Gustavo, María Eugenia, Gerardo,
                Helena y Carlos, todos profesionales. Las reuniones dominicales
                de todo el clan para confraternizar y decidir temas
                trascendentes eran obligatorias y puntuales, una variante de
                democracia familiar.
              </p>

              <p>
                En 1956 también cerró una brecha filial pendiente. A partir de
                setiembre de ese año, entabló correspondencia con Gustav Mohme,
                su padre, radicado en California, EE. UU., un carteo afectuoso
                que se mantuvo con regularidad semestral y se coronó el primero
                de octubre de 1965 con un abrazo de padre e hijo en Los Ángeles.
                Fue un encuentro sereno y definitivo. Tres meses después, el
                hijo recibió en Lima la noticia del deceso de Gustav. En Piura
                se sentaron las bases del desarrollo familiar y a mitad de
                camino, 1976, las exigencias de estudio, trabajo, empresa y
                sobre todo políticas del jefe de familia obligaron a emigrar a
                Lima.
              </p>
              <figure className="img-left img-mohme-5">
                <div className="block-red"></div>
                <img
                  src={Mohme8}
                  alt="En sus años de apoyo a la renovación
                política que representaba Fernando
                Belaunde Terry."
                  className="img-mohme-5"
                />
                <div className="legend">
                  En sus años de apoyo a la renovación política que representaba
                  Fernando Belaunde Terry.
                </div>
              </figure>
              <p>
                Participó en política. Gustavo Mohme Llona fue ingeniero civil,
                empresario de la construcción, político y periodista. Su
                actividad en esos campos abarcó toda la segunda mitad del siglo
                XX. Y es evidente que su quehacer más trascendente fue el
                político.
              </p>
              <p>
                El primer paso lo dio en el Frente Nacional de Juventudes
                Democráticas (FNJD), núcleo de jóvenes ingenieros que el primero
                de junio de 1956 impuso la inscripción de Fernando Belaunde
                Terry como candidato a la Presidencia de la República, a fuerza
                de una decidida manifestación de adherentes. El jurado electoral
                solo había inscrito al banquero Manuel Prado y al candidato de
                la dictadura, y se negaba a inscribir al FNJD, pero cedió.
                Belaunde fue inscrito y obtuvo la segunda votación. El FNJD se
                transformó en el partido Acción Popular.
              </p>
              <p>
                A lo largo de siete gobiernos mantuvo una orientación política
                principista y coherente.
              </p>
              <p>
                1961-63. En Acción Popular, participó presto en las campañas
                electorales que llevaron a Belaunde Terry a la Presidencia de la
                República y apoyó sus primeros 100 días de gestión. Su actitud
                varió en 1967 cuando el presidente, en confabulación con la
                Coalición Apra-UNO (odriismo), dio al asunto de La Brea y
                Pariñas una solución favorable a la International Petroleum. Por
                respeto al compromiso con los electores, Mohme Llona y Edgardo
                Seoane, vicepresidente y secretario general de AP, renunciaron
                al partido y formaron Acción Popular Socialista (APS).
              </p>
              <figure className="img-center">
                <div className="block-red"></div>
                <img
                  src={Mohme}
                  alt="Gustavo Mohme Llona en un mitin de la década de los noventa. En su actividad política, siempre mostró gran interés por la problemática social."
                  className=""
                />
                <div className="legend">
                  Gustavo Mohme Llona en un mitin de la década de los noventa.
                  En su actividad política, siempre mostró gran interés por la
                  problemática social.
                </div>
              </figure>
              <p>
                1968-69. Apoyó la nacionalización del petróleo y la reforma
                agraria decretadas por Velasco Alvarado, reformas nacionalistas
                y democráticas. Y luego respaldó transformaciones más profundas
                como la comunidad laboral, que daba participación a los
                trabajadores en las utilidades, gestión y propiedad de las
                empresas. Sinesio López calificó esta adhesión como un
                “desplazamiento del reformismo al socialismo”. Mohme ”no fue,
                por cierto, un marxista ni menos un leninista. Él apostó por un
                socialismo abierto que compatibilizara la justicia social con el
                desarrollo del individuo y de su libertad”, precisó el
                sociólogo.
              </p>
              <p>
                Según Mohme Llona, el trabajador juega un rol importante en la
                sociedad y el movimiento sindical es un aliado estratégico en
                las luchas sociales. Por eso, se identificó con el paro nacional
                del 19 de julio de 1977, que obligó a la gestión de Francisco
                Morales Bermúdez a convocar a una asamblea constituyente,
                aprobar una nueva Constitución, elegir un presidente y volver a
                la democracia.
              </p>
              <p>
                Mayo de 1980. La izquierda fraccionada presentó a las elecciones
                generales cinco candidatos, los que en conjunto obtuvieron
                apenas el 13.6 % de votos. La lección fue aprendida y en las
                municipales de setiembre de ese mismo año ya solo hubo uno:
                Alfonso Barrantes Lingán. Ganó el 28.6 % de las preferencias y
                ocupó el segundo lugar en Lima. El plato se repitió en 1983 y
                las preferencias escalaron al 36.14 %. "Frejolito" fue elegido
                alcalde de la capital. Uno de los artífices de ese logro y
                enseñanza tan vigente fue Mohme Llona.
              </p>
              <figure className="img-center">
                <div className="block-red-light"></div>
                <img
                  src={Mohme22}
                  alt="Mohme Llona fue una pieza clave para la unificación de la
                izquierda durante los años ochenta."
                  className=""
                />
                <div className="legend">
                  Mohme Llona fue una pieza clave para la unificación de la
                  izquierda durante los años ochenta. En la foto aparece con
                  algunos de sus principales líderes, en una visita a la ciudad
                  de Ayacucho tras el asesinato del alcalde Fermín Azparrent.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-red"></div>
                <img
                  src={Mohme7}
                  alt='Con su amigo Alfonso Barrantes Lingán, "Frejolito".'
                  className=""
                />
                <div className="legend">
                  Con su amigo Alfonso Barrantes Lingán, "Frejolito".
                </div>
              </figure>
              <div className="quote">
                "Que la ilegalidad sepa a qué atenerse si persiste en imponerle
                su voluntad a la mayoría de los peruanos".
              </div>
              <p>
                “… en una de esas caminatas largas por cerros y pendientes para
                la campaña del Tío Frejolito, 1983, yo me retrasaba y Gustavo
                Mohme, desde su altura, me divisaba y me pedía avanzar. Y al
                final, algo molesto, me dice: No te desaparezcas, te escurres y
                te pierdo de vista. Tenemos que avanzar juntos. Y yo le
                respondo: Un momento, mira tus piernas y las mías, ¿ahora ya
                sabes por qué no puedo seguirte el paso? Fíjense en esa frase:
                ‘Tenemos que avanzar juntos’, recoge el sentido de unidad”,
                rememora Gloria Helfer, maestra y excongresista.
              </p>
              <figure className="img-center">
                <div className="block-red-light"></div>
                <img
                  src={Mohme26}
                  alt="Desde el diario <em>La República</em> consolidó un bastión para la
                defensa de la democracia."
                  className=""
                />
                <div className="legend">
                  Desde el diario <em>La República</em> consolidó un bastión
                  para la defensa de la democracia.
                </div>
              </figure>
              <p>
                16 de noviembre de 1981. A un año y medio de iniciada la guerra
                interna provocada por Sendero Luminoso, Gustavo Mohme Llona
                fundó el diario <em>La República</em>, medio investigativo que
                cubrió el conflicto armado casi desde sus inicios, con
                independencia. Y, de hecho, varios de los crímenes de lesa
                humanidad cometidos por Sendero Luminoso, así como por el grupo
                Colina o las fuerzas del orden, fueron revelados por sus
                reporteros. La sentencia de 25 años a Alberto Fujimori se
                sustenta en denuncias de medios periodísticos independientes
                como <em>La República</em>, según han destacado José Ugaz,
                exprocurador, y Francisco Soberón, promotor de derechos humanos.
              </p>
              <figure className="img-center">
                <div className="block-red"></div>
                <img
                  src={Mohme37}
                  alt="En Cayara, como parte de una comisión encargada de investigar la
                muerte de comuneros ayacuchanos."
                  className=""
                />
                <div className="legend">
                  En Cayara, como parte de una comisión encargada de investigar
                  la muerte de comuneros ayacuchanos.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-red-light"></div>
                <img
                  src={Mohme47}
                  alt="Militares en la puerta del diario <em>La República</em> tras el golpe del 5 de abril de 1992."
                  className=""
                />
                <div className="legend">
                  Militares en la puerta del diario <em>La República</em> tras
                  el golpe del 5 de abril de 1992.
                </div>
              </figure>

              <p>
                5 de abril de 1992. Gustavo Mohme Llona emprendió una oposición
                firme, esclarecedora y sostenida ante el golpe de Estado
                asestado ese día por el presidente Alberto Fujimori y sus
                aliados. Cuestionó el modelo neoliberal extremo que promovió el
                régimen y que quedó reflejado en la Constitución de 1993.
                Denunció las violaciones a los derechos humanos y crímenes
                cometidos por el grupo Colin; desentrañó los actos de corrupción
                de Vladimiro Montesinos y Alberto Fujimori, y el abuso de poder
                del que se valieron para imponer la reelección del dictador.
              </p>
              <div className="clear">
                <figure className="img-left img-m">
                  <div className="block-red"></div>
                  <img
                    src={Mohme36}
                    alt="Con Valentín Paniagua, con quien enfrentó la dictadura de los años noventa."
                    className="img-m"
                  />
                  <div className="legend">
                    Con Valentín Paniagua, con quien enfrentó la dictadura de
                    los años noventa.
                  </div>
                </figure>
                <p>
                  En represalia por tanta entereza, Gustavo Mohme Llona fue
                  objeto de una campaña perversa de desprestigio y demolición de
                  su imagen pública a través de la “prensa chicha” o prensa del
                  SIN; inclusive se denunciaron intentos de atentados contra su
                  integridad, todo esto organizado desde los servicios de
                  inteligencia de la dictadura.
                </p>
              </div>
              <div className="clear">
                <figure className="img-right img-m">
                  <div className="block-red-light"></div>
                  <img
                    src={Javier}
                    alt="En el parlamento con Javier Diez Canseco."
                    className="img-m"
                  />
                  <div className="legend">
                    En el parlamento con Javier Diez Canseco.
                  </div>
                </figure>
                <p>
                  25 de noviembre de 1999. Fue suscrito el Acuerdo de
                  Gobernabilidad. Ha sido el aporte más serio desde la sociedad
                  civil en cuanto a la búsqueda de consensos para la gestión del
                  Estado. Lo firmaron trece organizaciones políticas. Gustavo
                  Mohme, siempre abierto al diálogo, fue uno de sus principales
                  promotores, y lo suscribió en nombre de Democracia y
                  Solidaridad (DEMOS).
                </p>
              </div>
              <div className="clear">
                <figure className="img-center">
                  <div className="block-red-light"></div>
                  <img
                    src={Mohme31}
                    alt="En su etapa como parlamentario."
                    className=""
                  />
                  <div className="legend">En su etapa como parlamentario.</div>
                </figure>
                <p>
                  El 23 de abril del 2000, un infarto segó su vida. Sus restos
                  descansan en el cementerio Jardines de la Paz, de Lima, desde
                  el 20 de octubre del 2018, acompañados de los de Stella Llona
                  Miller, su inolvidable madre, repatriados de Milán, Italia.
                </p>
              </div>
              <div className="clear mohme-end">
                <figure className="">
                  <img
                    src={Mohme45}
                    alt='Caricatura de Carlos Tovar, "Carlín".'
                    className=""
                  />
                  <div className="legend">
                    Caricatura de Carlos Tovar, "Carlín".
                  </div>
                </figure>
                <div className="quote">
                  "Tengo ideales que no he cumplido todavía; son ideales que,
                  estoy seguro, vamos a alcanzar tarde o temprano".
                </div>
              </div>
            </Fade>
          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/#nosotros"
            textPrev="1. Nosotros"
            next="https://fundacionmohme.org/especiales/memoria-2024/fundacion"
            textNext="1.2 La fundación"
            color="red"
          />
        </div>
      </div>
    </section>
  );
};

export default C1Nosotros;
